<app-shop-top-menu *ngIf="showTopMenu()"></app-shop-top-menu>
<div class="container content">
  <router-outlet></router-outlet>
</div>
